import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { InflabService } from '../../services/inflab.service';

@Component({
    selector: 'app-inflab',
    templateUrl: './inflab.component.html',
    styleUrls: ['./inflab.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class InflabComponent implements OnInit {

  labPCs: number[] = [];

  constructor(
    private inflabService: InflabService
  ) { }

  ngOnInit() {
    let i = 101;
    while (i <= 195) {
      this.labPCs.push(i);
      i++;
    }
  }

  click(pc: number) {
    this.inflabService.login(pc).subscribe();
  }
}
